import moment from "moment"
import { version } from "../../package.json"
import { userAccess, privileges } from "./userAccess"
import router from "@/router"
import store from "@/store"
// import VueSweetalert2 from "vue-sweetalert2"

const helpers = {
    getUserInfo() {
        const user = JSON.parse(localStorage.getItem('user')) 
        return user
    },
    getUserPosition() {
        const userPosition = this.getUserInfo().role_name
        return userPosition
    },
    getAccessToken() {
        const accessToken = JSON.parse(localStorage.getItem('accessToken'))
        return accessToken
    },
    // get list user access 
    getUserAccess(type) {
        const userRole = this.getUserInfo().role_name
        return userAccess[userRole].includes(type)
    },
    getPrivileges(priv) {
        let passed = 0
        if (priv.length > 0) {
            priv.forEach(val => {
                passed = this.getUserAccess(privileges[val]) ? passed += 1 : passed += 0
            })
        }
        return passed > 0 ? true : false
    },
    getApiUrl() {
        return process.env.VUE_APP_API_URL
    },
    getImageUrl() {
        return process.env.VUE_APP_IMAGE_URL
    },
    getVersionInfo() {
        return version
    },
    apiErrorResponse(status) {
        if (status !== 401) {
            store.dispatch('auth/logout')
            router.push('/login')
            // VueSweetalert2({
            //     title: 'Session Ended!',
            //     text: `Your access session ended. Please for login again.`,
            //     icon: 'warning',
            //     confirmButtonText: 'Okay',
            //     timer: 2000,
            //     timerProgressBar: true,
            //     customClass: {
            //         confirmButton: 'bg-theme-primary theme-rounded-sm'
            //     }
            // })
        }
    },
    // form data
    _formdata(data) {
        let formData= new FormData()

        const objectArray= Object.entries(data)

        objectArray.forEach(([key, value]) => {

            if (Array.isArray(value)){
            value.map(item => {
                formData.append(key+'[]' , item)
            })
            }else {
            formData.append(key, value)
            }
        })
        return formData
    },
    // date format
    dateFormat(date, format) {
        return moment(date).format(format)
    },
    // number format
    numberFormat(num) {
        const n = num.toFixed(0)
        if (n >= 1000 && n < 1000000) {
            return (n/1000).toFixed(1) + 'K'
        } else if (n >= 1000000) {
            return (n/1000000).toFixed(1) + 'M'
        } else {
            return Number(n).toLocaleString()
        }
    },
    // normalize text 
    normalizeText(text) {
        return text.replace("_", " ")
    },
    // capitalize text
    capitalizeFirstLetter(string) {
        return string.charAt(0).toUpperCase() + string.slice(1);
    },
    // rupiah format
    rupiahFormat(num) {
        return 'Rp, ' + num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".") + ',00'
    },
    // get AGE
    getAgeYear(date) {
        return moment().diff(moment(date, "Y-MM-DD"), 'years');
    }
}

export default helpers